<div class="logo-big">
  <img [src]="logo" />
</div>
<div class="password-container" [class.totp-mode]="setup">
  <h3 class="text-center">Recover Two-Factor Authentication</h3>
  <div class="form-container">
    @if (invalidLink) {
    <div class="error-container">
      <span class="error">
        <span class="error-message">This recovery link is invalid or has expired.</span>
      </span>
    </div>
    } @else if (!setup) {
    <form [formGroup]="setupForm" novalidate (ngSubmit)="onStartRecovery()">
      <div class="margin-bottom">Confirm your password to generate a new authenticator secret.</div>
      <div class="control password-input margin-bottom">
        <label for="currentPassword">Current Password</label>
        <lib-cm-input
          placeholder=""
          [type]="passwordVisibility ? 'text' : 'password'"
          formControlName="currentPassword"
          id="currentPassword"
          [titlecase]="false"
        ></lib-cm-input>
        <div class="password-visibility" (click)="passwordVisibility = !passwordVisibility">
          @if (passwordVisibility) {
          <span class="material-icons"> visibility </span>
          } @else {
          <span class="material-icons"> visibility_off </span>
          }
        </div>
      </div>
      <button type="submit" class="submit-btn margin-bottom" [disabled]="setupBtnDisabled">
        <div class="spinner-rect-container" [class.show]="setupLoading">
          <spinner-rect color="white"></spinner-rect>
        </div>
        <div class="title" [class.not-visible]="setupLoading">Continue</div>
      </button>
    </form>
    } @else {
    <form [formGroup]="confirmForm" novalidate (ngSubmit)="onConfirmRecovery()">
      <div class="totp-setup margin-bottom">
        <div class="totp-intro">
          <p>
            For extra security, CMS asks for a 6-digit authenticator code each time you log in, in
            addition to your Username and Password. Connect an authenticator app or browser
            extension to your account now. You only need to do this once.
          </p>
        </div>

        <section class="totp-step">
          <div class="totp-step-header">
            <span class="totp-step-number">1</span>
            <h5>Choose where to get your codes</h5>
          </div>
          <div class="totp-options">
            <div class="totp-option">
              <div class="totp-option-title">
                <span class="material-icons">smartphone</span>
                <span>On your phone</span>
              </div>
              <ol>
                <li>
                  Install an authenticator app, such as Google Authenticator or Microsoft
                  Authenticator.
                </li>
                <li>Open the app and add a new account.</li>
                <li>Scan the QR code below with the app.</li>
                <li>The app saves your CMS account and shows a 6-digit code.</li>
              </ol>
              <p class="totp-option-note">
                On iPhone, you can also scan with the Camera app. The code is then saved in the
                <strong>Passwords</strong> app.
              </p>
            </div>
            <div class="totp-option">
              <div class="totp-option-title">
                <span class="material-icons">computer</span>
                <span>On your computer</span>
              </div>
              <ol>
                <li>
                  Install an authenticator extension in your browser, such as Authenticator
                  (authenticator.cc) for Chrome, Edge or Firefox.
                </li>
                <li>Open the extension and choose the scan option.</li>
                <li>Select the QR code below on this page.</li>
                <li>The extension saves your CMS account and shows a 6-digit code.</li>
              </ol>
            </div>
          </div>
        </section>

        <section class="totp-step">
          <div class="totp-step-header">
            <span class="totp-step-number">2</span>
            <h5>Scan this QR code</h5>
          </div>
          <img
            alt="QR code for setting up two-factor authentication"
            class="qr-code"
            [attr.src]="qrCode"
          />
          <div class="secret-key">
            <span
              ><strong>Can’t scan the code?</strong> In your app or extension, choose to enter a
              setup key, then type this key:</span
            >
            <code>{{ secretKey }}</code>
          </div>
        </section>

        <section class="totp-step">
          <div class="totp-step-header">
            <span class="totp-step-number">3</span>
            <h5>Enter the code from your app</h5>
          </div>
          <div class="control">
            <label for="code">Authenticator Code</label>
            <lib-cm-input
              placeholder=""
              formControlName="code"
              id="code"
              [titlecase]="false"
            ></lib-cm-input>
          </div>
          <span class="totp-hint">
            Enter all 6 digits shown in your app, including any leading zero. The code changes every
            30 seconds.
          </span>
        </section>
      </div>

      <button type="submit" class="submit-btn margin-bottom" [disabled]="confirmBtnDisabled">
        <div class="spinner-rect-container" [class.show]="confirmLoading">
          <spinner-rect color="white"></spinner-rect>
        </div>
        <div class="title" [class.not-visible]="confirmLoading">Confirm</div>
      </button>
    </form>
    }
    <div class="link text-center">
      <a routerLink="/login">Back to login</a>
    </div>
  </div>
</div>
